import PartiesAndPrecinct from './PartiesAndPrecinct';

export default PartiesAndPrecinct;
